import axios from 'axios'

// 舆情服务使用独立的 HTTP 状态码和响应结构，不走旧 CSMS 的 status/value 包装。
// 舆情能力已迁入 csmsapi；环境变量只用于测试环境覆盖网关前缀。
const prefix = (process.env.VUE_APP_YUQING_API_PREFIX || 'lechun-csms/api').replace(/^\/+|\/+$/g, '')
let redirectingToLogin = false

function endpoint(path) {
  return `${prefix}/${String(path || '').replace(/^\/?api\//, '').replace(/^\//, '')}`
}

function url(path) {
  const target = endpoint(path)
  if (/^https?:\/\//i.test(target)) return target
  const base = axios.defaults.baseURL || window.location.origin
  return new URL(target, `${base.replace(/\/$/, '')}/`).toString()
}

function errorMessage(error) {
  if (error && error.code === 'ECONNABORTED') return '更新请求等待超过 60 秒，后台可能仍在处理，请稍后刷新页面核对结果'
  const data = error && error.response && error.response.data
  const detail = data && data.error
  return (detail && typeof detail === 'object' && detail.message) ||
    (typeof detail === 'string' && detail) ||
    (data && data.message) ||
    (error && error.message) ||
    '网络异常，请稍后重试'
}

function redirectToLogin() {
  if (redirectingToLogin || /\/login(?:\?|$)/.test(window.location.pathname + window.location.search)) return
  redirectingToLogin = true
  const returnPage = encodeURIComponent(window.location.href)
  window.location.href = `/login?auth=1&returnPage=${returnPage}`
}

function unauthorized(error) {
  const response = error && error.response
  const data = response && response.data
  const businessCode = data && data.error && data.error.code
  if (response && response.status === 403 && businessCode === 'ADMIN_FORBIDDEN') return false
  return (response && (response.status === 401 || response.status === 403)) || (data && data.status === 20112)
}

async function request(method, path, data, config) {
  try {
    const response = await axios({
      url: endpoint(path), method, data,
      timeout: 60000,
      withCredentials: true,
      ...(config || {})
    })
    if (response.data && response.data.status === 20112) {
      redirectToLogin()
      throw new Error(response.data.message || '登录已失效，请重新登录')
    }
    return response.data
  } catch (error) {
    if (unauthorized(error)) redirectToLogin()
    throw new Error(errorMessage(error))
  }
}

export const yuqingApi = {
  get(path, params) { return request('get', path, undefined, { params }) },
  post(path, data) { return request('post', path, data, { headers: { 'Content-Type': 'application/json' } }) },
  put(path, data) { return request('put', path, data, { headers: { 'Content-Type': 'application/json' } }) },
  delete(path) { return request('delete', path) },
  upload(path, form) { return request('post', path, form) },
  download(path) { window.open(url(path), '_blank', 'noopener') }
}

export function yuqingURL(path) { return url(path) }

// 候选内容只影响自动舆情展示；读取失败不能阻断追踪内容和概览的其它数据。
export async function loadLatestCandidates() {
  const latest = await yuqingApi.get('runs/latest')
  if (!latest || !latest.run) return { run: null, candidates: [], error: '' }
  try {
    const payload = await yuqingApi.get(`runs/${latest.run.id}`)
    return { run: latest.run, candidates: payload.collected_items || [], error: '' }
  } catch (error) {
    return { run: latest.run, candidates: [], error: error.message || '自动发现内容暂不可用' }
  }
}

export async function loadHistoricalContents(platform) {
  const payload = await yuqingApi.get('public-opinion/contents', { platform: platform || undefined, limit: 200 })
  return payload.items || []
}

export async function loadHistoricalComments (platform, sourceId) {
  const payload = await yuqingApi.get('public-opinion/comments', { platform, sourceId, limit: 100 })
  return payload.items || []
}

export async function loadLatestDashboard() {
  const latest = await yuqingApi.get('runs/latest')
  if (!latest || !latest.run) return { run: null, collected_comments: [] }
  return yuqingApi.get(`runs/${encodeURIComponent(latest.run.id)}`)
}
